import { AddressFragment } from '@graphql/platform';

/** An address created on the client (e.g. via Google autocomplete) */
export type ClientAddress = Omit<AddressFragment, 'id'> & {
  googleAddressType?: string;
};

export enum ADDRESS_VALIDATION {
  INCOMPLETE = 'Oops! This address is not complete. Please search again',
}
